/* eslint-disable no-undef */
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant';
import thunkMiddleware from 'redux-thunk';

import { addLocaleData, IntlProvider } from 'react-intl';
import pt from 'react-intl/locale-data/pt';

import AppProvider from './shared/providers';

import 'moment/locale/pt-br';
import 'react-select/dist/react-select.css';
import 'react-toastify/dist/ReactToastify.css';
import RootReducer from './redux';

import App from './App';
import { sessionMiddleware } from './redux/middleware/session-middleware';

const customerCompanyId = window.localStorage.getItem(
  'Luft/CustomerService/CompanyId',
);
const userCompanyId = window.localStorage.getItem('Luft/CompanyId');
const divisions = window.localStorage.getItem('Luft/CustomerService/Divisions');

const tagManagerArgs = {
  gtmId: process.env.NODE_ENV === 'production' ? 'GTM-TM7QL6Q' : '',
  dataLayer: {
    userId: window.localStorage.getItem('Luft/UserId'),
    companyId: customerCompanyId || userCompanyId,
    divisionId: divisions,
  },
};
TagManager.initialize(tagManagerArgs);

addLocaleData([...pt]);

// store definition
let enhancer;
// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') {
  enhancer = compose(applyMiddleware(thunkMiddleware, sessionMiddleware));
} else {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  enhancer = composeEnhancers(
    applyMiddleware(immutableStateInvariantMiddleware(), thunkMiddleware, sessionMiddleware),
  );
}

export const store = createStore(RootReducer, enhancer);

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale="pt-BR" textComponent={({ children }) => children}>
      <MuiThemeProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </MuiThemeProvider>
    </IntlProvider>
  </Provider>,
  document.getElementById('root'),
);
